import React from 'react';
import {useIntl} from 'react-intl';

import {Badge} from './badge';

type Props = {
    className?: string;
    show?: boolean;
};

export const GuestPlusBadge = ({show = true, className = ''}: Props) => {
    const {formatMessage} = useIntl();

    const message = formatMessage({
        id: 'post_info.guest_plus',
        defaultMessage: 'Guest +',
    });

    return (
        <Badge className={className} show={show}>
            {message}
        </Badge>
    );
};
